import React from "react"

import styles from "./nav-bar-spacer.module.scss"
import classnames from "classnames/bind"
const cx = classnames.bind(styles)

export const NavBarSpacer = () => <div className={cx("nav-bar-spacer")}></div>
